
import { defineComponent } from '@nuxtjs/composition-api';
import WarRoomCommissionEarnBannerChecklist from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBannerChecklist.vue';
import WarRoomCommissionEarnBannerGift from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBannerGift.vue';
import WarRoomCommissionEarnBannerMoreWays from '@/components/partials/war-room/WarRoomCommissionEarnBanner/WarRoomCommissionEarnBannerMoreWays.vue';
import {
  bannerTypes,
  commissionBannerTooltipName,
} from '@/components/partials/war-room/WarRoomCommissionEarnBanner/constants';

import CommissionOnboardingQuery from '@/apollo/queries/CommissionOnboarding.query';

import type { CommissionOnboarding } from '@/types/graphql';

export default defineComponent({
  name: 'WarRoomCommissionEarnBanner',
  components: {
    WarRoomCommissionEarnBannerChecklist,
    WarRoomCommissionEarnBannerGift,
    WarRoomCommissionEarnBannerMoreWays,
  },
  apollo: {
    commissionOnboarding: {
      query: CommissionOnboardingQuery,
      skip() {
        return !this.$auth.loggedIn;
      },
      deep: true,
    },
  },
  data(): { commissionOnboarding: CommissionOnboarding | null } {
    return {
      commissionOnboarding: null,
    };
  },
  computed: {
    componentData(): { name: string; props: { product?: unknown; items?: unknown[] | null | undefined } } {
      if (this.commissionOnboarding) {
        switch (this.commissionOnboarding.type) {
          case bannerTypes.COMMISSION_EXCHANGE:
            return { name: 'WarRoomCommissionEarnBannerGift', props: { product: this.commissionOnboarding?.product } };
          case bannerTypes.WAYS_TO_EARN_COMMISSION:
            return { name: 'WarRoomCommissionEarnBannerMoreWays', props: {} };
          case bannerTypes.EARN_COMMISSION:
          default:
            return { name: 'WarRoomCommissionEarnBannerChecklist', props: { items: this.commissionOnboarding?.items } };
        }
      } else {
        return { name: 'WarRoomCommissionEarnBannerChecklist', props: { items: [] } };
      }
    },
    isVisible(): boolean {
      if (this.$tooltip.isPresent(commissionBannerTooltipName)) return false;

      return !!this.commissionOnboarding;
    },
  },
});
